import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { type ForecastDay, type ForecastHour } from '../../shared/types';
import { getForecastDays, getForecastHours } from '../utilities/api';

export const queryKeys = {
    getForecastDays: (id: string) => ['forecasts', 'forecastDay', 'get', `${id}`],
    getForecastHours: (id: string, utcDate: string) => ['forecasts', 'forecastHour', 'get', `${id}`, `${utcDate}`],
};

export const useForecastDays = (id: string): UseQueryResult<ForecastDay[], Error> => {
    return useQuery({ queryKey: queryKeys.getForecastDays(id), queryFn: () => getForecastDays(id), retry: false, refetchInterval: 300000, refetchIntervalInBackground: true });
};

export const useForecastHours = (id: string, utcDate: string): UseQueryResult<ForecastHour[], Error> => {
    return useQuery({
        queryKey: queryKeys.getForecastHours(id, utcDate),
        queryFn: () => getForecastHours(id, utcDate),
        retry: false,
        refetchInterval: 300000,
        refetchIntervalInBackground: true,
    });
};

export const invalidateForecasts = (queryClient: QueryClient): void => {
    queryClient.invalidateQueries({ queryKey: ['forecasts'] });
};
